import * as React from "react";
import { useParams } from "react-router-dom";
import { HangarStateContainer } from "../../containers/HangarStateContainer";
import { HangarsStateContainer } from "../../containers/HangarsStateContainer";
import { PredefinedObstaclesContainer } from "../../containers/PredefinedObstaclesContainer";
import { RampsStateContainer } from "../../containers/RampsStateContainer";
import { TowingEquipmentContainer } from "../../containers/TowingEquipmentContainer";
import { ScheduledHangarView } from "../Schedule/ScheduledHangarView/ScheduledHangarView";
import { HangarStack } from "./Hangar";

type Props = {
  hangarId?: string;
};

export const HangarSchedule: React.FC<Props> = ({
  hangarId,
}) => {
  const { id: hangarIdFromRoute } = useParams();
  const [stacks, setStacks] = React.useState<HangarStack[]>([]);

  return (
    // Same container structure as regular Hangar component
    <RampsStateContainer isReference={false}>
      <HangarsStateContainer isReference={false}>
        <HangarStateContainer
          initialState={{
            hangar_id: hangarId ?? hangarIdFromRoute,
            isReference: false,
          }}
        >
          <PredefinedObstaclesContainer>
            <TowingEquipmentContainer>
              <ScheduledHangarView
                id={hangarIdFromRoute}
                stacks={stacks}
                setStacks={setStacks}
                isReference={false}
                isAlgorithmTesting={false}
              />
            </TowingEquipmentContainer>
          </PredefinedObstaclesContainer>
        </HangarStateContainer>
      </HangarsStateContainer>
    </RampsStateContainer>
  );
};